"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyHeaders = exports.setHeader = exports.isRedirect = exports.mergeResponses = void 0;
const server_1 = require("next/server");
const constants_1 = require("../constants");
/**
 * A function that merges two Response objects into a single response.
 * The final response respects the body and the status of the last response,
 * but the cookies and headers of all responses are merged.
 */
const mergeResponses = (...responses) => {
    const normalisedResponses = responses.filter(Boolean).map(res => new server_1.NextResponse(res.body, res));
    if (normalisedResponses.length === 0) {
        return;
    }
    const lastResponse = normalisedResponses[normalisedResponses.length - 1];
    const finalResponse = new server_1.NextResponse(lastResponse.body, lastResponse);
    for (const response of normalisedResponses) {
        response.headers.forEach((value, name) => {
            finalResponse.headers.set(name, value);
        });
        response.cookies.getAll().forEach(cookie => {
            finalResponse.cookies.set(cookie.name, cookie.value);
        });
    }
    return finalResponse;
};
exports.mergeResponses = mergeResponses;
const isRedirect = (res) => {
    return res.headers.get(constants_1.constants.Headers.NextRedirect);
};
exports.isRedirect = isRedirect;
const setHeader = (res, name, val) => {
    res.headers.set(name, val);
    return res;
};
exports.setHeader = setHeader;
const stringifyHeaders = (headers) => {
    if (!headers) {
        return JSON.stringify({});
    }
    const obj = {};
    headers.forEach((value, name) => {
        obj[name] = value;
    });
    return JSON.stringify(obj);
};
exports.stringifyHeaders = stringifyHeaders;
